import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestoreRubricPromptVersion,
  type FirestoreInteractiveElementPromptVersion,
  type FirestorePostRoomStatePromptVersion,
  emptyInteractiveElementPromptVersion,
  emptyPostRoomStatePromptVersion,
  emptyRubricPromptVersion,
} from '../firestore/PromptVersion'
import type { FirebaseRepository } from './FirebaseRepository'

type PromptVersion =
  | FirestoreRubricPromptVersion
  | FirestoreInteractiveElementPromptVersion
  | FirestorePostRoomStatePromptVersion

class BasePromptVersion<
  T extends PromptVersion,
> extends ObservableModelWithDecorators<T> {
  constructor(repository: FirebaseRepository, doc: MobxDocument<T>) {
    super(repository, doc)
  }
}

export class RubricPromptVersion extends BasePromptVersion<FirestoreRubricPromptVersion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptyRubricPromptVersion)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptyRubricPromptVersion)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRubricPromptVersion>
  ) {
    super(repository, doc)
  }
}

export class InteractiveElementPromptVersion extends BasePromptVersion<FirestoreInteractiveElementPromptVersion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptyInteractiveElementPromptVersion)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(
      repository,
      this,
      emptyInteractiveElementPromptVersion
    )
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreInteractiveElementPromptVersion>
  ) {
    super(repository, doc)
  }
}

export class PostRoomStatePromptVersion extends BasePromptVersion<FirestorePostRoomStatePromptVersion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptyPostRoomStatePromptVersion)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptyPostRoomStatePromptVersion)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePostRoomStatePromptVersion>
  ) {
    super(repository, doc)
  }
}
